export default __webpack_public_path__ + "static/vegan-6b124d8478101a5be3f55eba74ec8f80.svg";